import React, { ReactNode } from 'react';
import DefaultContent from './DefaultContent';
import withTheme from '../../../hocs/withTheme';
import '../Footer.css';

type FooterMiniProps = {
    children?: ReactNode;
};

function FooterMini({
    children = <DefaultContent />,
} : FooterMiniProps) {
    return (
        <footer className="Footer Footer_mini">
            <div className="container Footer__bottom">
                {children}
            </div>
        </footer>
    );
}

export default withTheme(FooterMini);
